export const getVideos = async ( search ) => {
	return await fetch( `/search/?q=${search}`, {
		method: 'POST',
		credentials: 'same-origin',
		headers: {
			'X-Requested-With': 'XMLHttpRequest',
			'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8',
		},
	} ).then( ( response ) => {
		if ( !response.ok )
		{
			throw new Error( `Could not fetch, status: ${response.status}` );
		}

		return response.json();
	} );
};
